// src/components/store/sections/faqs/FaqV89ClaytogglesSunsetAmber.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV89ClaytogglesSunsetAmber(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={89}
      archKey="clay_toggles"
      archLabel="3D Claymorphic Toggles"
      palName="SunsetAmber"
      grad="from-amber-500 via-orange-500 to-red-600"
      lightBg="bg-amber-50"
      textCol="text-amber-800"
      borderCol="border-amber-200"
      btnCls="bg-orange-600 hover:bg-orange-700"
      hexCol="#f59e0b"
      {...props}
    />
  );
}
